<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>



        <!-- titulo y boton crear -->
        <v-row v-if="componenteEvento.agregar_submodulo">
            <v-col class="d-flex flex-row-reverse">
                <TableButtonComp normalButton textButton="Crear coordinación" iconBut="fas fa-plus"
                    @click="aggCoordinacion" />
            </v-col>
            <v-col cols="12">
                <ComundataTablecomp :headers="coordinacionHeaders" :items="coordinaciones" whitSearch :search="search">
                    <template v-slot:respon="{ item }">
                        <span :class="item.tipo === -1 ? 'red--text' : ''">
                            {{ item.tipo === -1 ? 'Sin responsable' : item.nombre_persona }}
                        </span>
                    </template>
                    <template v-slot:numdoc_persona="{ item }">
                        <span>
                            {{ item.tipo === -1 ? '---' : item.numdoc_persona }}
                        </span>
                    </template>

                    <template v-slot:Tipo="{ item }">
                        <v-chip :color="item.tipo === 1 ? '#6abf69' : item.tipo === -1 ? '0277bd' : 'blue'" dark small
                            class="font-weight-black">
                            {{ item.tipo === 1 ? 'Encargado' : item.tipo === -1 ? 'Sin asignar ' : 'Suplente' }}
                        </v-chip>
                    </template>


                    <template v-slot:accion="{ item }">

                        <v-menu absolute offset-y style="width:300px">

                            <template v-slot:activator="{ on }">
                                <v-row justify="space-around" v-on="on">
                                    <img class="button-group" src="@/assets/iconos/button-icon-group-coordinacion.svg"
                                        height="35px" width="80px">
                                </v-row>
                            </template>

                            <v-card class="card-icon">
                                <v-tooltip bottom color="#1b1b1b" v-if="item.id_estado == null">
                                    <template v-slot:activator="{ on }">
                                        <div class="template-button">
                                            <p class="text-icon">Agregar responsable</p>

                                            <v-btn v-on="on" class="success ma-3 mt-8 ml-5 " fab x-small
                                                :disabled="componenteEvento.agregar_submodulo != 1"
                                                @click="aggResponsable(item, 'Asignar responsable')">
                                                <img src="@/assets/iconos/icon_agregar_responsable.svg" height="23px"
                                                    width="40px">
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Agregar responsable</span>
                                </v-tooltip>

                                <v-tooltip bottom color="#1b1b1b" v-else>
                                    <template v-slot:activator="{ on }">
                                        <div class="template-button">
                                            <p class="text-icon">Reasignar responsable</p>

                                            <v-btn v-on="on" class="success ma-3 mt-8 ml-5" fab x-small
                                                :disabled="componenteEvento.editar_submodulo != 1"
                                                @click="reasigResponsable(item, 'Reasignar responsable')">
                                                <img src="@/assets/iconos/icon_agregar_responsable.svg" height="23px"
                                                    width="40px">
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Reasignar responsable</span>
                                </v-tooltip>

                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <div class="template-button">
                                            <p class="text-icon">Editar responsable</p>

                                            <v-btn v-on="on" class="warning ma-3 mt-8 ml-3" fab x-small
                                                @click="editarResponsable(item)"
                                                :disabled="item.id_estado === null || componenteEvento.editar_submodulo != 1">
                                                <img src="@/assets/iconos/icon_editar_responsable.svg" height="23px"
                                                    width="40px">
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Editar responsable</span>
                                </v-tooltip>

                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <div class="template-button">
                                            <p class="text-icon">Eliminar responsable</p>

                                            <!-- @click="deleteResponsable(item)" -->
                                            <v-btn v-on="on" class="ma-3 mt-8 ml-6 btn_eliminar" fab x-small
                                                @click="confirmDeleteResponsale(item)"
                                                :disabled="item.id_estado === null || componenteEvento.borrar_submodulo != 1">
                                                <img src="@/assets/iconos/icon_eliminar_responsable.svg" height="23px"
                                                    width="40px">
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Eliminar responsable</span>
                                </v-tooltip>

                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <div class="template-button">
                                            <p class="text-icon">Editar coordinación</p>

                                            <v-btn v-on="on" class="ma-3 mt-8 warning" fab x-small
                                                :disabled="componenteEvento.editar_submodulo != 1"
                                                @click="editCoordinacion(item, 'EDITANDO COORDINACIÓN')">
                                                <img src="@/assets/iconos/icon_editar_coordinacion.svg" height="23px"
                                                    width="40px">
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Editar coordinación</span>
                                </v-tooltip>

                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <div class="template-button">
                                            <p class="text-icon">Seguimiento</p>

                                            <v-btn v-on="on" class="ma-3 mt-8 ml-4 primary" fab x-small
                                                :disabled="componenteEvento.editar_submodulo != 1"
                                                @click="getAllSeguimiento(item, 'Seguimiento de coordinación')">
                                                <img src="@/assets/iconos/icon_seguimiento.svg" height="23px" width="40px">
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Seguimiento</span>
                                </v-tooltip>

                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <div class="template-button">
                                            <p class="text-icon">Eliminar coordinación</p>

                                            <v-btn v-on="on" class="ma-3 mt-8 ml-4 btn_eliminar" fab x-small
                                                :disabled="componenteEvento.borrar_submodulo != 1"
                                                @click="confirmDelete(item)">
                                                <img src="@/assets/iconos/icon_eliminar_coordinacion.svg" height="23px"
                                                    width="40px">
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Eliminar coordinación</span>
                                </v-tooltip>

                            </v-card>

                        </v-menu>
                    </template>
                </ComundataTablecomp>
            </v-col>
        </v-row>




        <ComunDialogComp v-model="modal_agg_coordinacion" :title="titleModal" maxWidth="500" @close-modal="closeModalCoor">
            <template v-slot:body>
                <v-alert type="info" outlined="" class="">{{ text_accion }}</v-alert>
                <div class="d-flex flex-wrap  align-center justify-space-around" v-if="selector">
                    <v-btn @click="validarAmbito('nivel')" color="primary" elevation="2" outlined rounded large width="45%"
                        class="my-2"> Nivel
                    </v-btn>
                    <v-btn @click="validarAmbito('grado')" color="primary" elevation="2" outlined rounded large width="45%"
                        class="my-2">
                        Grado
                    </v-btn>
                    <v-btn @click="validarAmbito('area')" color="primary" elevation="2" outlined rounded large width="45%"
                        class="my-2">
                        Área
                    </v-btn>
                    <v-btn @click="validarAmbito('curso')" color="primary" elevation="2" outlined rounded large width="45%"
                        class="my-2">
                        {{ $t('titulo.curso') }}
                    </v-btn>


                </div>

                <v-row dense>
                    <v-col cols="12" v-if="nivel">
                        <!------select de Niveles ------->
                        <v-select v-model="elNivel" @change="getAllGradosArea(elNivel)" :items="niveles"
                            item-text="desc_nivel" item-value="id" label="Nivel" :multiple="flag == 'nivel'"
                            :return-object="flag == 'nivel'"></v-select>
                    </v-col>


                    <v-col cols="12" v-if="grado">
                        <!-------select de grados ------->
                        <!-- {{ grados }} -->
                        <v-select v-model="elGrado" @change="getAllCurso(elGrado, 'grado')" :items="grados"
                            item-text="desc_grado" :multiple="flag !== 'curso'" item-value="id" label="Grado"
                            :return-object="flag !== 'curso'"></v-select>
                    </v-col>


                    <v-col cols="12" v-if="area">
                        <!------ select de areas ---->
                        <v-select v-model="laArea" @change="getAllCurso(laArea, 'area')" :items="areas"
                            item-text="desc_area" item-value="id" label="Área"></v-select>
                    </v-col>


                    <v-col cols="12" v-if="curso">
                        <!-----select  de cursos ----->
                        <v-select v-model="elCurso" :items="cursos" item-text="desc_curso" item-value="id"
                            :label="$t('titulo.cursos')"></v-select>
                    </v-col>


                    <v-col cols="12" v-if="nombre && nivel">
                        <v-text-field label="Nombre de coordinación"
                            v-model="coordinacion.nombre_coordinacion"></v-text-field>
                    </v-col>

                    <v-col cols="12" class="py-0" v-if="observacion_editar">
                        <v-textarea v-model='observacion_edicion' name="input-7-4" label="Observación"></v-textarea>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:actions>
                <v-spacer />
                <TableButtonComp normalButton v-if="agregar_Coor" @click="addCoordinacion" textButton="Guardar"
                    iconBut="fas fa-save" />
                <TableButtonComp normalButton v-if="editar_Coor && canSubmit"
                    @click="updateCoordinacion(coordinacion.id_coord)" textButton="Guardar cambios" iconBut="fas fa-save" />
                <TableButtonComp normalButton classButton="ml-2" @click="closeModalCoor" classColor="red"
                    textButton="Cancelar" />

            </template>
        </ComunDialogComp>








        <!---- seccion de modales  --->
        <!----modal editar Responsable--->
        <ComunDialogComp v-model="modal_editar" maxWidth="400" title="Editar responsable" @close-modal="closeModalEdicion">
            <template v-slot:body>
                <v-row>
                    <v-col cols="12">
                        <div class="docente-seleccionado">
                            <h2>{{ Coordedit.nombre_persona }}</h2>
                        </div>

                    </v-col>

                    <v-col cols="12" class="py-0">
                        <v-chip class="primary">Tipo de responsable:</v-chip>

                        <v-radio-group :mandatory="false" v-model='Coordedit.tipo'>
                            <v-radio v-for="item of opciones" :key="item.id" :label="item.label" :color="item.color"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                    </v-col>

                    <v-col cols="12" class="py-0">
                        <v-textarea v-model='observacion_editada' @keyup="validarBotonEditar" outlined name="input-7-4"
                            label="Observación"></v-textarea>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:actions>
                <v-spacer />
                <TableButtonComp normalButton @click="editResponsable(Coordedit.id)" textButton="Guardar cambios"
                    iconBut="fas fa-save" />
                <TableButtonComp normalButton @click="closeModalEdicion" textButton="Cancelar" classColor="red"
                    classButton="ml-2" />
            </template>
        </ComunDialogComp>








        <!--- modal de acciones seleccionadas --->
        <ComunDialogComp v-model="modal_acciones" maxWidth="1100" :title="titleAccion" @close-modal="closeModalAcciones">
            <template v-slot:body>
                <component :is="componentName" :reasignacion='reasign' :coord='coordinacion' :tipo='tag'
                    :Historial='Seguimiento' :Coordinacion='laCoordinacion' @asignacion='asignarResponsable'>
                </component>
            </template>
        </ComunDialogComp>



        <!-- MODAL CONFIRMACIÓN ELIMINAR COORDINAcion -->
        <ComunDialogComp Deletedialog v-model="modal_delete" @close-modal="modal_delete = false"
            @cancel-item="modal_delete = false" @delete-item="deleteCoordinacion" titleWindow="Eliminar coordinación">
            <template v-slot:body>
                ¿Está seguro de eliminar este registro?
                <br>
                Nombre coordinación:
                <v-chip color="yellow" small>
                    {{ coordinador_delete.nombre_coordinacion || "Nombre coordinador" }}
                </v-chip>
            </template>
        </ComunDialogComp>

        <!-- modal de Confirmacion de eliminacion de coordinador -->
        <ComunDialogComp Deletedialog v-model="modal_deleteCordinador" @close-modal="modal_deleteCordinador = false"
            @cancel-item="modal_deleteCordinador = false" @delete-item="deleteResponsable(item)"
            titleWindow="Eliminar responsable">
            <template v-slot:body>
                ¿Está seguro de eliminar este registro?
            </template>
        </ComunDialogComp>



        <span v-if="test">
            Eventos all: <code>{{ componenteEvento }}</code> <br />
        </span>





    </div>
</template>




<script>
import axios from "../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import responsable from '@/views/Administrativo/Coordinaciones/Components/Responsable.vue';
import seguimiento from '@/views/Administrativo/Coordinaciones/Components/Seguimiento.vue';
import ComundataTablecomp from '../../../components/ComponentsEst/ComundataTablecomp.vue';
import { coordinacionHeaders } from '../../../helpers/headersTable';
import ComunDialogComp from '../../../components/ComponentsEst/ComunDialogComp.vue';
import TableButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';

export default {
    name: 'Coordinaciones',
    components: {
        TableButtonComp,
        ComundataTablecomp,
        ComunDialogComp,
        responsable,
        seguimiento
    },

    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { "id_modulo": 6, 'id_submodulo': 66 }, // modulo y sud_modulo 

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////

        coordinacionHeaders,
        componentName: '',
        temptitle: '',
        test: false,
        // permisos:{},
        //datos para props
        reasign: false,
        dialogdelete: false,
        tag: 0,
        laCoordinacion: '',
        inicial: '',

        editedCoor: -1,
        modal_agg_coordinacion: false,
        modal_acciones: false,
        modal_editar: false,

        agregar_Coor: false,
        editar_Coor: false,
        selector: true,
        text_accion: '',
        titleAccion: '',
        id_colegio: sessionStorage.id_colegio,
        ano_lectivo: sessionStorage.id_ano_lectivo,
        flag: '',
        observacion_editar: false,
        observacion_edicion: '',
        observacion_editada: '',
        btn_editar_responsable: false,

        nivel: false,
        grado: false,
        area: false,
        curso: false,
        nombre: false,

        elNivel: null,
        elGrado: [],
        laArea: null,
        elCurso: null,

        niveles: [],
        grados: [],
        areas: [],
        cursos: [],
        coordinaciones: [],
        Seguimiento: [],
        Coordedit: [],

        coordinacion: {
            id_colegio: sessionStorage.id_colegio,
            id_ano_lectivo: sessionStorage.id_ano_lectivo,
            id_nivel: null,
            id_grado: null,
            id_area: null,
            id_curso: null,
            nombre_coordinacion: '',
            id_personal: null,
            nombre_persona: '',
            id_tipo_documento: null,
            numdoc_persona: '',
            id_estado: 1,
            id_estado_reasignacion: null,
            id_us_ing: sessionStorage.id,
            id_us_mod: sessionStorage.id,
            status: 1,
            tipo: null,
            observacion_asignacion: '',
            observacion_reasignacion: '',
            aux: 0
        },


        defaultCoordinacion: {
            id_colegio: sessionStorage.id_colegio,
            id_ano_lectivo: sessionStorage.id_ano_lectivo,
            id_nivel: null,
            id_grado: null,
            id_area: null,
            id_curso: null,
            nombre_coordinacion: '',
            id_personal: null,
            nombre_persona: '',
            id_tipo_documento: null,
            numdoc_persona: '',
            id_estado: 1,
            id_estado_reasignacion: null,
            id_us_ing: sessionStorage.id,
            id_us_mod: sessionStorage.id,
            status: 1,
            tipo: null,
            observacion_asignacion: '',
            observacion_reasignacion: '',
            aux: 0
        },


        parametros: {
            id_colegio: sessionStorage.id_colegio,
            id_anio_lectivo: sessionStorage.id_ano_lectivo,
            id_adm_nivel: null,
            id_grado: null,
            id_area: null,
            id_curso: null
        },

        search: '',

        opciones: [
            { label: "ENCARGADO", color: "info", value: 1 },
            { label: "SUPLENTE ", color: "info", value: 0 },
        ],

        //Para el modal confirmar eliminar 
        modal_delete: false,
        modal_deleteCordinador: false, //Modal delete confirm
        coordinador_delete: null,
        isPending: false


    }),


    computed: {
        ...mapGetters('login', ['componenteEvento']),

        titleModal() {
            // const temptitle = this.nivel ? ' - nivel': this.grado? ' - grado' : this.area? ' - area' :this.curso? ' - curso' : '' ;
            return this.editedCoor === -1 ? 'Crear coordinación' + this.temptitle : 'Editar coordinación' + this.temptitle
        },

        //Condicional para el nuevo feature que indica que al crear una nueva coordinación se debe seleccionar todos los campos en cualquier tipo de los 4 modales
        canSubmit() {
            if (this.flag == 'nivel' && (!this.elNivel || !this.coordinacion.nombre_coordinacion)) {
                this.setEnviarMens({ tipo: `W`, mensaje: `Debe seleccionar todos los campos.`, tiempo: null });
                return false;
            } else if (this.flag == 'grado' && (!this.elNivel || !this.elGrado || !this.coordinacion.nombre_coordinacion)) {
                this.setEnviarMens({ tipo: `W`, mensaje: `Debe seleccionar todos los campos.`, tiempo: null });
                return false;
            } else if (this.flag == 'area' && (!this.elNivel || !this.laArea || !this.coordinacion.nombre_coordinacion)) {
                this.setEnviarMens({ tipo: `W`, mensaje: `Debe seleccionar todos los campos.`, tiempo: null });
                return false;
            } else if (this.flag == 'curso' && (!this.elNivel || !this.elGrado || !this.laArea || !this.elCurso || !this.coordinacion.nombre_coordinacion)) {
                this.setEnviarMens({ tipo: `W`, mensaje: `Debe seleccionar todos los campos.`, tiempo: null });
                return false;
            } else {
                return true;
            }
        }
    },

    created() {
        this.actualizarParamentro()
    },
    mounted() {
        this.getAllCoordinaciones()
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)


        },


        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////


        // funcion de inhabilitar selects -----
        selectsOff() {
            this.nivel = false
            this.grado = false
            this.area = false
            this.curso = false
            this.elNivel = null
            this.elGrado = null
            this.laArea = null
            this.elCurso = null
            this.flag = ''
        },


        //  abrir modal para agregar coordinacion
        aggCoordinacion() {
            //validamos que exista un año lectivo activo de lo contario mostramos mensaje
            if (this.datoLogin.id_ano_lectivo > 0) {
                this.modal_agg_coordinacion = true
                this.text_accion = 'SELECCIONE UN ÁMBITO PARA CREAR COORDINACIÓN'
                this.agregar_Coor = true
                this.editar_Coor = false
            } else {
                this.setEnviarMens({ tipo: "E", mensaje: 'No existe un año lectivo activo. Caso contrario vuelva a iniciar sessión.', tiempo: 5500 })
            }
        },


        // funcion para validar el ambito y consultar niveles
        async validarAmbito(tipo) {
            try {
                const params = {
                    id_ano_lectivo: sessionStorage.id_ano_lectivo,
                    id_colegio_adm_nivel: sessionStorage.id_colegio
                }

                // var opcion = tipo.toUpperCase();
                this.selector = false
                this.text_accion = `SELECCIONE`
                const res = await axios.post("/administrativo/nivel/niveladmin", params);
                this.niveles = res.data
                switch (tipo) {
                    case 'nivel':
                        this.nivel = true
                        this.flag = 'nivel'
                        this.temptitle = ' - Nivel'
                        this.nombre = true
                        break;
                    case 'grado':
                        this.nivel = true
                        this.grado = true
                        this.flag = 'grado'
                        this.temptitle = ' - Grado'
                        this.nombre = true
                        break;
                    case 'area':
                        this.nivel = true
                        this.area = true
                        this.temptitle = ' - Área'
                        this.flag = 'area'
                        this.nombre = true
                        break;
                    case 'curso':
                        this.nivel = true
                        this.grado = true
                        this.area = true
                        this.flag = 'curso'
                        this.temptitle = ' - Curso'
                        this.nombre = true
                        break;
                }
            }
            catch (error) {
                //console.log(error)
            }

        },


        //----consultar los Grados  o areas dependiendo el caso -----
        async getAllGradosArea(id) {
            try {
                this.parametros.id_adm_nivel = id
                if (this.flag === 'grado') {
                    const resp = await axios.post("/administrativo/coordinacion/all/gr/", this.parametros);
                    this.grados = resp.data
                }

                else if (this.flag === 'area') {
                    const resp = await axios.post("/administrativo/coordinacion/all/ar/", this.parametros);
                    this.areas = resp.data
                }

                else if (this.flag === 'curso') {
                    const resp = await axios.post("/administrativo/coordinacion/all/gr/", this.parametros);
                    this.grados = resp.data
                    const resp2 = await axios.post("/administrativo/coordinacion/all/ar/", this.parametros);
                    this.areas = resp2.data
                }
            }
            catch (error) {
                //console.log(error)
            }
        },


        //--------Traer los Curso---------
        async getAllCurso(id, tipo) {
            if (this.flag === 'grado') {
                //console.log('agregar');
            }
            else {
                try {
                    if (tipo === 'area' && !this.parametros.id_grado) {
                        this.parametros.id_area = id
                    }
                    else if (tipo === 'grado' && !this.parametros.id_area) {
                        this.parametros.id_grado = id
                    }

                    else if (tipo === 'area' && this.parametros.id_grado) {
                        this.parametros.id_area = id
                        const resp = await axios.post("/administrativo/coordinacion/all/cur/", this.parametros);
                        this.cursos = resp.data
                        this.curso = true
                    }

                    else if (tipo === 'grado' && this.parametros.id_area) {
                        this.parametros.id_grado = id
                        const resp = await axios.post("/administrativo/coordinacion/all/cur/", this.parametros);
                        this.cursos = resp.data
                        this.curso = true
                    }
                }
                catch (error) {
                    //console.log(error)
                }
            }

        },


        //**********traer todas las coordinaciones  */
        async getAllCoordinaciones() {

            this.permisos = this.componenteEvento
            try {
                let params = {
                    id_colegio: sessionStorage.id_colegio,
                    id_anio_lectivo: sessionStorage.id_ano_lectivo
                }
                const response = await axios.post('/administrativo/coordinacion/coord/all/', params);
                //console.log(response.data)
                this.coordinaciones = response.data
            }

            catch (error) {
                //console.log(error)
            }
        },


        //*************agregar nueva coordinacion ****** */
        async addCoordinacion() {
            try {
                if (!this.canSubmit) {
                    return;
                }

                const arrayPromesas = []

                switch (this.flag) {
                    case 'nivel':
                        this.elNivel.forEach(nivel => {
                            const params = {
                                ...this.coordinacion,
                                nombre_coordinacion: this.coordinacion.nombre_coordinacion + ' - ' + nivel.desc_nivel,
                                id_nivel: nivel.id
                            }
                            arrayPromesas.push(axios.post("/administrativo/coordinacion/", params))
                        });
                        break;
                    case 'grado':

                        this.elGrado.forEach(grado => {

                            const params = {
                                ...this.coordinacion,
                                nombre_coordinacion: this.coordinacion.nombre_coordinacion + ' - ' + grado.desc_grado,
                                id_grado: grado.id
                            }
                            arrayPromesas.push(axios.post("/administrativo/coordinacion/", params))
                        });

                        break;
                    case 'area':

                        this.coordinacion.id_area = this.laArea
                        arrayPromesas.push(axios.post('/administrativo/coordinacion/', this.coordinacion))

                        break;
                    case 'curso':
                        this.coordinacion.id_curso = this.elCurso;
                        arrayPromesas.push(axios.put('/administrativo/coordinacion/', this.coordinacion))

                        break;
                    default:
                        break;
                }
                // console.log('Esta es el postdata', postData);
                await Promise.all(arrayPromesas);
                this.getAllCoordinaciones();
                this.closeModalCoor();
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },


        // funcion de asignacion de docente **********
        async asignarResponsable(id) {
            try {
                const response = await axios.put('/administrativo/coordinacion/iu/' + id, this.coordinacion)
                this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null })
                this.getAllCoordinaciones()
                this.closeModalAcciones()
            }
            catch (error) {
                //console.log(error)
            }
        },


        // funcion para editar responsable *********
        async editResponsable(id) {
            this.Coordedit.aux = 2
            this.Coordedit.observacion_reasignacion = this.observacion_editada
            this.Coordedit.id_us_mod = sessionStorage.id

            try {
                const response = await axios.put('/administrativo/coordinacion/iu/' + id, this.Coordedit);
                this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null })
                this.getAllCoordinaciones()
                this.closeModalEdicion()
            }
            catch (error) {
                //console.log(error)
            }
        },



        // ****  actualizar nombre de una coordinacion
        async updateCoordinacion(id) {
            if (this.observacion_edicion === '') {

                alert('Debes agregar una observacion para editar')
            }
            else {
                try {
                    this.coordinacion.observacion_asignacion = this.observacion_edicion
                    const response = await axios.put('/administrativo/coordinacion/updcoord/' + id, this.coordinacion);
                    this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null });
                    this.getAllCoordinaciones()
                    this.closeModalCoor()
                }
                catch (error) {
                    //console.log(error)
                }
            }
        },


        //----cierre de modal de coordinacion y logica de blanqueado de parametros y ocultamientos
        closeModalCoor() {
            this.selectsOff()
            this.parametros.id_adm_nivel = null
            this.parametros.id_grado = null
            this.parametros.id_area = null
            this.parametros.id_curso = null
            this.coordinacion.nombre_coordinacion = ''
            this.coordinacion.id_nivel = null
            this.coordinacion.id_grado = null
            this.coordinacion.id_area = null
            this.coordinacion.id_curso = null
            this.modal_agg_coordinacion = false
            this.selector = true
            this.observacion_editar = false
            this.observacion_edicion = ''
            this.temptitle = ''
            this.editedCoor = -1
        },


        //******cierre de modal de accion y blanqueo de arreglo */
        closeModalAcciones() {
            this.coordinacion.id_personal = null
            this.coordinacion.nombre_persona = ''
            this.coordinacion.id_tipo_documento = null
            this.coordinacion.numdoc_persona = ''
            this.coordinacion.aux = 0
            this.coordinacion.observacion_asignacion = ''
            this.coordinacion.observacion_reasignacion = ''
            this.coordinacion.id_estado_reasignacion = null
            this.modal_acciones = false
            this.componentName = ''
            this.reasign = false
        },


        //********cierre de modal editar , y blanqueo de arreglo */
        closeModalEdicion() {
            this.modal_editar = false
            this.Coordedit = []
            this.btn_editar_responsable = false
        },


        //------funciones de acciones e injeccion de componente------
        //------aperturar modal de acciones ------
        aggResponsable(item, title) {
            this.tag = 1
            this.coordinacion.id_coord = item.id
            this.componentName = 'responsable'
            this.modal_acciones = true
            this.titleAccion = title
        },


        //-------reasignacion de responsable --------
        reasigResponsable(item, title) {
            this.tag = 2
            this.coordinacion.id_coord = item.id
            this.reasign = true
            this.modal_acciones = true
            this.titleAccion = title
            this.componentName = 'responsable'
        },


        editarResponsable(item) {
            //var letra = item.nombre_apellido.charAt(1);
            //this.inicial = letra.toUpperCase();
            this.modal_editar = true
            this.Coordedit = item
            this.observacion_editada = (item.observacion_reasignacion) ? item.observacion_reasignacion : item.observacion_asignacion
            this.validarBotonEditar()
        },


        validarBotonEditar() {
            if (this.observacion_editada.length > 0) {
                //if(this.Coordedit.observacion_asignacion.length > 0 ){
                this.btn_editar_responsable = true
            } else {
                this.btn_editar_responsable = false
            }
        },


        //---------seguimiento -------
        async getAllSeguimiento(item, title) {
            try {
                this.modal_acciones = true
                this.titleAccion = title
                this.laCoordinacion = item.nombre_coordinacion
                this.componentName = 'seguimiento'
                const response = await axios.get('/administrativo/coordinacion/ch/all/' + item.id + '');
                this.Seguimiento = response.data
                //console.log(this.Seguimiento)
            }
            catch (error) {
                //console.log(error)
            }
        },


        /******apertura para edicion de coordinacion */
        editCoordinacion(item, title) {
            this.text_accion = title
            this.observacion_editar = true
            this.modal_agg_coordinacion = true
            this.selector = false
            this.coordinacion.nombre_coordinacion = item.nombre_coordinacion
            this.coordinacion.id_coord = item.id
            this.editar_Coor = true
            this.agregar_Coor = false
            this.editedCoor = 1
            this.observacion_edicion = item.observacion_asignacion
        },


        /********eliminacion de responsable de la coordinacion */
        async deleteResponsable() {
            let params = { id_us_mod: sessionStorage.id }
            const id = this.responsable_delete.id

            try {
                const response = await axios.put('/administrativo/coordinacion/dc/p/' + id, params)
                this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null })
                this.getAllCoordinaciones()
            }
            catch (error) {
                this.setEnviarMens({ tipo: 'E', mensaje: 'Error al eliminar coordinador', tiempo: null })
                console.log(error);
            }
            finally {
                this.modal_deleteCordinador = false
            }
        },

        async deleteCoordinacion() {
            //console.log(item)
            try {
                this.isPending = true
                const id = this.coordinador_delete.id
                if (this.coordinador_delete.id_estado === null) {
                    const response = await axios.delete('/administrativo/coordinacion/' + id)
                    this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null });
                    this.getAllCoordinaciones()
                }
                else {
                    // let params = {
                    //     id_us_mod: sessionStorage.id,
                    //     observacion_asignacion: 'Coordinacion Eliminada...'
                    // }
                    const response = await axios.put('/administrativo/coordinacion/dc/' + id);
                    this.setEnviarMens({ tipo: `${response.data.messageT}`, mensaje: `${response.data.message}`, tiempo: null });
                    this.getAllCoordinaciones()
                }

            }
            catch (error) {
                this.setEnviarMens({ tipo: 'E', mensaje: 'Error al eliminar coordinación', tiempo: null })
                console.log(error);
            }
            finally {

                this.isPending = false
                this.modal_delete = false
            }
        },

        confirmDeleteResponsale(responsable_delete) {
            this.responsable_delete = responsable_delete
            this.modal_deleteCordinador = true
        },

        // ABRIR MODAL COORDINACIÓN
        confirmDelete(coordinador_delete) {
            this.coordinador_delete = coordinador_delete
            this.modal_delete = true
        },

        /**********eliminacion de coordinacion **** */

    }
}
</script>



<style scoped>
.titulo-modal {
    color: #fff;
}

.btn-coor {
    width: 48%;
    height: 70px;
    background: #E6E6E6;
    margin-left: 7px;
    margin-bottom: 20px;
    font-size: 26px;
    color: #2956C8;
    cursor: pointer;
    border: 2px solid #2956C8;
    text-transform: uppercase;
}

@media(max-width: 425px) {
    .btn-coor {
        width: 100%;
    }
}

.btn-coor:hover {
    border: none;
    background: #2956C8;
    color: #fff;
    box-shadow: 5px 5px 5px #A4A4A4;
}

.botones-coordinacion {
    margin: 5% auto;
}

.button-group {
    border-radius: 5px;
    cursor: pointer;
}

.button-group:hover {
    box-shadow: 5px 5px 5px #A4A4A4;
}

.icon-group {
    border: 1px solid #A4A4A4;
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
    opacity: .5;
}

.icon-group:hover {
    box-shadow: 5px 5px 5px #A4A4A4;
    opacity: 1;
}

.card-icon {
    border: 2px solid #2956C8;
    padding: 3px;
}

.template-button {
    position: relative;
    display: inline-block;
}

.template-button .text-icon {
    position: absolute;
    font-size: 10px;
    text-align: center;
}

.docente-seleccionado {
    width: 100%;
    background: #E6E6E6;
    height: 62px;
    border-left: 6px solid #045FB4;
    border-right: 6px solid #045FB4;
    padding-top: 21px;
    position: relative;
}

.docente-seleccionado h2 {
    color: #045FB4;
    text-transform: uppercase;
    text-align: center;
}

.docente-seleccionado .avatar-profesor {
    position: absolute;
    top: 7px;
    left: 16px;
}

#container {
    margin-bottom: 100px;
}
</style>